module.exports = __webpack_public_path__ + "static/media/redcircle@2x.a5b872e1.png";